'use strict';

import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';

import NutritionInfo from '@components/Products/NutritionInfo.react';

import { useModalControls, usePermissions } from '../contexts';
import './MenuStats.scss';

const MenuStats = ({
    plan,
    user,
    profile,
    analysis
}) => {
    const [isExpanded, setIsExpanded] = useState(false);
    const { showGroceries } = useModalControls();
    const { canViewNutrition } = usePermissions();

    // Memoize the grocery click handler to avoid recreating on each render
    const handleGroceryClick = useCallback(() => {
        if (user) {
            showGroceries();
        }
    }, [user, showGroceries]);

    return (
        <div className="plan-editor-stats" data-showall={isExpanded} data-collapsible={true}>
            {canViewNutrition && (
                <NutritionInfo nutrients={analysis?.nutrients} profile={{...profile, portion: 1}} envelope={analysis?.envelope} />
            )}

            <section className="other-insights">
                <div className="insight">
                    <em>{Math.round((analysis?.hands_on_time || 0) / 60)}<span>min</span></em>
                    <p>daily avg prep time</p>
                </div>

                <div className="insight">
                    <em>${(analysis?.avg_cost_per_serving || 0).toFixed(2)}</em>
                    <p>Per serving avg cost</p>
                </div>

                <div className="insight groceries" onClick={handleGroceryClick}>
                    <em>{analysis?.total_fresh || 0}</em>
                    <p># of fresh ingredients</p>
                </div>

                <div className="insight groceries" onClick={handleGroceryClick}>
                    <em>{analysis?.total_pantry || 0}</em>
                    <p># of pantry ingredients</p>
                </div>

                <div className="insight">
                    <em>{Math.round((1 - (analysis?.efficiency_score || 0)) * 100)}%</em>
                    <p>Produce <br />Waste</p>
                </div>
            </section>
        </div>
    );
};

MenuStats.propTypes = {
    plan: PropTypes.object.isRequired,
    user: PropTypes.object,
    profile: PropTypes.object,
    analysis: PropTypes.object,
};

export default MenuStats;
